import { getFinancingOfferDetails } from '../utils/get-financing-offer-details';
import {
  IFinancingOfferCampaign,
  IFinancingOfferFormatted,
} from '~/interfaces/synchrony/synchrony-interfaces';
import {
  //   TODO:: IN STORE Offers - LIMITED
  //   LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer,
  SynchronyConfiguration,
  FeatureFlag,
  Maybe,
} from '~/gql/__generated__/types';

import SynchronyLearnHow from './synchrony-learn-how';
import {
  getCampaignRemainingCost,
  getValidSpecialCampaign,
} from '~/modules/payment/synchrony/utils/financing-offer-calculation-utils';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { IPaymentState } from '~/interfaces/payment';
import { isFeatureEnabled } from '~/utils/utils';
import { IS_MS_CHAT_ENABLED } from '~/constant/constants';

interface CheckoutSynchronyLearnHowProps {
  checkoutOffer: IFinancingOfferFormatted;
  checkoutCart: ISalesOrderResponse;
  checkoutConfigs: SynchronyConfiguration;
  learnHowCtaNameForCashback?: string;
  activeTab?: number;
  progressiveTotalAmount?: number;
  ctaType?: string;
  isExtraPromoEligible?: boolean;
  paymentState?: IPaymentState;
  featureFlags?: Maybe<Maybe<FeatureFlag>[]> | undefined;
  isOfferLoading?: boolean;
}

const LearnHowSideDrawer = ({
  checkoutOffer,
  checkoutCart,
  checkoutConfigs,
  learnHowCtaNameForCashback,
  activeTab,
  progressiveTotalAmount,
  ctaType,
  isExtraPromoEligible,
  paymentState,
  featureFlags,
  isOfferLoading,
}: CheckoutSynchronyLearnHowProps) => {
  const selectedOffer =
    checkoutOffer ||
    getFinancingOfferDetails(checkoutConfigs, checkoutCart.balanceAmount);

  if (!selectedOffer) {
    return null;
  }

  const enableMSChat = isFeatureEnabled(featureFlags ?? [], IS_MS_CHAT_ENABLED);

  const campaign:
    | IFinancingOfferCampaign
    //   TODO:: IN STORE Offers - LIMITED
    // | LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer
    | undefined = getValidSpecialCampaign(selectedOffer);

  const campaignRemainingCost =
    campaign && checkoutCart.balanceAmount
      ? getCampaignRemainingCost(
          campaign,
          selectedOffer,
          checkoutCart.balanceAmount,
        )
      : undefined;

  return (
    <SynchronyLearnHow
      selectedOffer={selectedOffer}
      campaign={campaign}
      campaignRemainingCost={campaignRemainingCost}
      bspConfigs={checkoutConfigs}
      cart={checkoutCart}
      learnHowCtaNameForCashback={learnHowCtaNameForCashback}
      activeTab={activeTab}
      progressiveTotalAmount={progressiveTotalAmount}
      ctaType={ctaType}
      isExtraPromoEligible={isExtraPromoEligible}
      paymentState={paymentState}
      enableMSChat={enableMSChat}
      isOfferLoading={isOfferLoading}
    />
  );
};

export default LearnHowSideDrawer;
